import type { ScheduleEntry } from '@/services/drivers/driverService';
import type { DrivingLogSettings } from '@/types/organizations';
import { mergeDrivingLogOrgSettings } from '@/utils/organizationDrivingLogDefaults';

/** Mån–fre, samma tjänsttid (API: day_of_week 0 = måndag). */
export function buildWeekdayServiceScheduleFromOrg(
  settings: DrivingLogSettings | null | undefined
): ScheduleEntry[] {
  const s = mergeDrivingLogOrgSettings(settings ?? null);
  const start = (s.defaultServiceStart || '07:00').substring(0, 5);
  const end = (s.defaultServiceEnd || '17:00').substring(0, 5);
  return [0, 1, 2, 3, 4].map((day_of_week) => ({
    day_of_week,
    start_time: start,
    end_time: end,
  }));
}
